var getRGB = function (c) {
    return parseInt(c, 16) || c;
};
var getsRGB = function (c) {
    return getRGB(c) / 255 <= 0.03928
        ? getRGB(c) / 255 / 12.92
        : Math.pow((getRGB(c) / 255 + 0.055) / 1.055, 2.4);
};
var getLuminance = function (hexColor) {
    return (0.2126 * getsRGB(hexColor.substr(1, 2)) +
        0.7152 * getsRGB(hexColor.substr(3, 2)) +
        0.0722 * getsRGB(hexColor.substr(-2)));
};
var getContrast = function (bgColor, textColor) {
    var L1 = getLuminance(bgColor);
    var L2 = getLuminance(textColor);
    return (Math.max(L1, L2) + 0.05) / (Math.min(L1, L2) + 0.05);
};
export var getTextColor = function (bgColor) {
    var whiteContrast = getContrast(bgColor, '#ffffff');
    var blackContrast = getContrast(bgColor, '#000000');
    return whiteContrast > blackContrast ? '#ffffff' : '#000000';
};
export var getHostname = function (url) {
    if (!url)
        return '';
    var parseUrl = new URL(url);
    return parseUrl.hostname || '';
};
